import type {
  ICity,
  ICommunity,
  ICountry,
  IDataCompanySettings,
  IFilter,
  IGender,
} from '@/types/Data'
import type { ICriteria } from '@/types/Request'
import type { ICriteriaStore } from '@/types/Store/State'
import { defineStore } from 'pinia'
export const useCriteriaStore = defineStore('criteria', {
  state: (): ICriteriaStore => ({
    filterId: [],
    genderId: [],
    departmentId: [],
    positionId: [],
    cityId: [],
    countryId: [],
    locationId: [],
    employeeWorkerTypeId: [],
    levelId: [],
    communityId: null,
    startDate: '',
    endDate: '',
    refreshKey: 0,
  }),

  actions: {
    SET_FILTERID(arr: IFilter[]) {
      this.filterId = arr
    },
    SET_GENDERID(arr: IGender[]) {
      this.genderId = arr
    },
    SET_DEPARTMENTID(arr: IDataCompanySettings[]) {
      this.departmentId = arr
    },
    SET_POSITIONID(arr: IDataCompanySettings[]) {
      this.positionId = arr
    },
    SET_CITYID(arr: ICity[]) {
      this.cityId = arr
    },
    SET_COUNTRYID(arr: ICountry[]) {
      this.countryId = arr
    },
    SET_LOCATIONID(arr: IDataCompanySettings[]) {
      this.locationId = arr
    },
    SET_EMPLOYEEWORKERTYPEID(arr: IDataCompanySettings[]) {
      this.employeeWorkerTypeId = arr
    },
    SET_LEVELID(arr: IDataCompanySettings[]) {
      this.levelId = arr
    },
    SET_COMMUNITYID(community: ICommunity) {
      this.communityId = community
    },
    DELETE_FILTERID(id: string) {
      const index = this.filterId.findIndex((item: IFilter) => item.id === id)
      if (index !== -1) {
        this.filterId.splice(index, 1)
      }
    },
    DELETE_GENDERID(id: string) {
      const index = this.genderId.findIndex((item: IGender) => item.id === id)
      if (index !== -1) {
        this.genderId.splice(index, 1)
      }
    },
    DELETE_DEPARTMENTID(id: string) {
      const index = this.departmentId.findIndex((item: IDataCompanySettings) => item.id === id)
      if (index !== -1) {
        this.departmentId.splice(index, 1)
      }
    },
    DELETE_POSITIONID(id: string) {
      const index = this.positionId.findIndex((item: IDataCompanySettings) => item.id === id)
      if (index !== -1) {
        this.positionId.splice(index, 1)
      }
    },
    DELETE_CITYID(id: string) {
      const index = this.cityId.findIndex((item: ICity) => item.id === id)
      if (index !== -1) {
        this.cityId.splice(index, 1)
      }
    },
    DELETE_COUNTRYID(id: string) {
      const index = this.countryId.findIndex((item: ICountry) => item.id === id)
      if (index !== -1) {
        this.countryId.splice(index, 1)
      }
    },
    DELETE_LOCATIONID(id: string) {
      const index = this.locationId.findIndex((item: IDataCompanySettings) => item.id === id)
      if (index !== -1) {
        this.locationId.splice(index, 1)
      }
    },
    DELETE_EMPLOYEEWORKERTYPEID(id: string) {
      const index = this.employeeWorkerTypeId.findIndex(
        (item: IDataCompanySettings) => item.id === id,
      )
      if (index !== -1) {
        this.employeeWorkerTypeId.splice(index, 1)
      }
    },
    DELETE_LEVELID(id: string) {
      const index = this.levelId.findIndex((item: IDataCompanySettings) => item.id === id)
      if (index !== -1) {
        this.levelId.splice(index, 1)
      }
    },
    DELETE_COMMUNITYID() {
      this.communityId = null
    },

    SET_DATES(startDate: Date | string, endDate: Date | string) {
      this.startDate = startDate
      this.endDate = endDate
      this.TRIGGER_FILTERS()
    },

    TRIGGER_FILTERS() {
      this.refreshKey = Date.now()
    },

    RESET_FILTERS() {
      this.filterId = []
      this.genderId = []
      this.departmentId = []
      this.positionId = []
      this.cityId = []
      this.countryId = []
      this.locationId = []
      this.employeeWorkerTypeId = []
      this.levelId = []
      this.communityId = null
    },
  },

  getters: {
    getFilterId: state => state.filterId,
    getGenderId: state => state.genderId,
    getDepartmentId: state => state.departmentId,
    getPositionId: state => state.positionId,
    getCityId: state => state.cityId,
    getCountryId: state => state.countryId,
    getLocationId: state => state.locationId,
    getEmployeeWorkerTypeId: state => state.employeeWorkerTypeId,
    getCommunityId: state => state.communityId,
    getLevelId: state => state.levelId,
    getFilters(state): ICriteria {
      return {
        DepartmentId: state.departmentId.length > 0 ? state.departmentId.map(item => item.id) : [],
        FilterId: state.filterId.length > 0 ? state.filterId.map(item => item.id) : [],
        GenderId: state.genderId.length > 0 ? state.genderId.map(item => item.id) : [],
        PositionId: state.positionId.length > 0 ? state.positionId.map(item => item.id) : [],
        CityId: state.cityId.length > 0 ? state.cityId.map(item => item.id) : [],
        CountryId: state.countryId.length > 0 ? state.countryId.map(item => item.id) : [],
        LocationId: state.locationId.length > 0 ? state.locationId.map(item => item.id) : [],
        EmployeeWorkerTypeId:
          state.employeeWorkerTypeId.length > 0
            ? state.employeeWorkerTypeId.map(item => item.id)
            : [],
        LevelId: state.levelId.length > 0 ? state.levelId.map(item => item.id) : [],
        CommunityId: state.communityId !== null ? state.communityId.id : null,
      }
    },
    getDates(state) {
      return {
        startDate: state.startDate,
        endDate: state.endDate,
      }
    },
    getRefreshKey: (state): number => state.refreshKey,
  },
})
